import { render, staticRenderFns } from "./ManterUsuarioView.vue?vue&type=template&id=4b5aecda&scoped=true"
import script from "./ManterUsuarioView.vue?vue&type=script&lang=js"
export * from "./ManterUsuarioView.vue?vue&type=script&lang=js"
import style0 from "./ManterUsuarioView.vue?vue&type=style&index=0&id=4b5aecda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5aecda",
  null
  
)

export default component.exports